import { 
    GET_INVOICES_FAIL, 
    GET_INVOICES_LOADING, 
    GET_INVOICES_SUCCESS, 
    POST_INVOICES_FAIL, 
    POST_INVOICES_LOADING,
    POST_INVOICES_SUCCESS,
    POST_REQUEST_CONTROL_NUMBER_FAIL,
    POST_REQUEST_CONTROL_NUMBER_LOADING,
    POST_REQUEST_CONTROL_NUMBER_SUCCESS} from "../Components/Constants/ActionTypes";


const Invoices = (state,{type,payload})=>{
    switch (type) {
        case GET_INVOICES_LOADING:
            return{
                ...state,
                getInvoices:{
                ...state.getInvoices,
                loading:true
              }
            };
        case GET_INVOICES_SUCCESS:
            return {
                ...state,
                getInvoices:{
                    ...state.getInvoices,
                    loading:false,
                    data:payload,
                }
            };
        case GET_INVOICES_FAIL:
            return{
                ...state,
                getInvoices:{
                    ...state.getInvoices,
                    loading:false,
                    error:payload,
                }
            };
        case POST_INVOICES_LOADING:
            return{
                ...state,
                postInvoice:{
                ...state.postInvoice,
                loading:true
                }
            };
        case POST_INVOICES_SUCCESS:
            return {
                ...state,
                postInvoice:{
                    ...state.postInvoice,
                    loading:false,
                    data:payload,
                }
            };
        case POST_INVOICES_FAIL:
            return{
                ...state,
                postInvoice:{
                    ...state.postInvoice,
                    loading:false,
                    error:payload,
                }
            };
        case POST_REQUEST_CONTROL_NUMBER_LOADING:
            return{
                ...state,
                postControlNumberState:{
                ...state.postControlNumberState,
                loading:true
                }
            };
        case POST_REQUEST_CONTROL_NUMBER_SUCCESS:
            return {
                ...state,
                postControlNumberState:{
                    ...state.postControlNumberState,
                    loading:false,
                    data:payload,
                }
            };
        case POST_REQUEST_CONTROL_NUMBER_FAIL:
            return{
                ...state,
                postControlNumberState:{
                    ...state.postControlNumberState,
                    loading:false,
                    error:payload,
                }
            };
    }
}

export default Invoices;